export { Validator } from './Validator';
export { isValidEmail } from './ValidatorFns/EmailValidator';
export { isValidPesel } from './ValidatorFns/PeselValidator';
